import React from 'react';

function FaviconLinks() {
  return (
    <>
      <link rel="icon" type="image/png" sizes="512x512" href="/assets/imgs/brand/favicon-512.png" />
      <link rel="icon" type="image/png" sizes="256x256" href="/assets/imgs/brand/favicon-256.png" />
      <link rel="icon" type="image/png" sizes="192x192" href="/assets/imgs/brand/favicon.png" />
      <link rel="icon" type="image/png" sizes="128x128" href="/assets/imgs/brand/favicon-128.png" />
      <link rel="icon" type="image/png" sizes="64x64" href="/assets/imgs/brand/favicon-64.png" />
      <link rel="icon" type="image/png" sizes="48x48" href="/assets/imgs/brand/favicon-48.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/assets/imgs/brand/favicon-32.png" />
      <link rel="shortcut icon" href="/assets/imgs/brand/favicon.png" />
      <link rel="apple-touch-icon" sizes="180x180" href="/assets/imgs/brand/apple-touch-icon.png" />
    </>
  );
}

export default FaviconLinks;
